"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var root = typeof window === 'undefined' ? global : window;

/**
 * @typedef {object} SellerModel
 */
var Seller = module.exports = SoaModel.extend();
var Agreement                         = require('bunsen/models/identity/Agreement');
var Dealers                           = require('bunsen/collections/identity/Sellers');
var User                              = require('bunsen/models/identity/User');
var Backbone                          = require('dibs-backbone');
var moment                            = require('moment');
var SoaModelLabelAndValueTransformer  = require('bunsen/models/SoaModelLabelAndValueTransformer');
var SoaCollection                     = require('bunsen/collections/SoaCollection');
var UserProfile                       = require('bunsen/models/identity/UserProfile');
var ShipmentQuote                     = require('bunsen/models/logistics/ShipmentQuote');
var Period                            = require('bunsen/models/Period');
var fetchRelationMixin                = require('bunsen/models/mixins/fetchRelation');
var SellerAdjustment                  = require('bunsen/models/ecomm/SellerAdjustment');
var SellerBillingProfile              = require('bunsen/models/identity/SellerBillingProfile');
var SellerPaymentProfile              = require('bunsen/models/identity/SellerPaymentProfile');
var TradeAssociation                  = require('bunsen/models/identity/TradeAssociation');
var TradeAssociations                 = require('bunsen/collections/identity/TradeAssociations');
var ReturnPolicy                      = require('bunsen/models/identity/ReturnPolicy');
//var Shipping = require('bunsen/models/Shipping'); // TODO: refactor to use new shipping models
//var ShippingCollection = require('bunsen/collections/ShippingCollection');
var ShipmentQuotes                    = require('bunsen/collections/logistics/ShipmentQuotes');
var Address                           = require('bunsen/models/Address');
var dataProvider                      = require('bunsen/helpers/dataProvider');
var verticals                         = require('dibs-vertical-helpers');
var endpoints                         = require('dibs-endpoints');
var legacyId                          = require('bunsen/helpers/legacyId');
var _                                 = require('underscore');
var $                                 = require('dibs-jquery-shim');
var Notes                             = require('bunsen/collections/Notes');
var Note                              = require('bunsen/models/Note');
var SellerPreferences                 = require('bunsen/models/identity/SellerPreferences');
var AnchorLists                       = require('bunsen/collections/identity/AnchorLists');
var FeeStructure                      = require('bunsen/models/ecomm/FeeStructure');
var FeeStructures                     = require('bunsen/collections/ecomm/FeeStructures');
var TwentyFirstCenturyStatus          = require('./identity/TwentyFirstCenturyStatus.es');

var sellers = [];

/**
 * Defining relatedModel collection to stateTaxAdjustments
 * @typedef {object} AdjustmentsModel
 */
var StateTaxAdjustments = SoaModel.extend({
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/taxAdjustment';
        return url;
    },
    relations : [{
        key : 'adjustments',
        collectionType: SoaCollection.extend({
            model: SellerAdjustment
        }),
        type: Backbone.Many
    }]
});

/**
 * Hold all agreements for the seller
 * @type {*}
 */
var SellerAgreements = SoaModel.extend({
    model: SoaModel,
    url : function () {
        return _.result(this.findParent(Seller), 'url') + '/agreement';
    },
    relations : [{
        key : 'agreementList',
        collectionType: SoaCollection.extend({
            model: Agreement
        }),
        type: Backbone.Many
    }]
});

var SellerStore = SoaModel.extend({
    // Assign the URL to the store using the path to the parent Seller's URL (with the correct ID)
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/store';
        return url;
    },
    defaults: {
        address : {},
        district : {},
        country : {},
        state : {},
        continent: {},
        region : {}
    },
    // Since the distinct and address sub-models are simple one to one relationships at this level, use the
    // createRelations method to do it quickly... this assumes SoaModel as the related model, and
    // Backbone.One relationship type.
    relations : function () {
        return SoaModel.createRelations(['district', 'address', 'country', 'state', 'region', 'continent']);
    }

});

var SellerProfile = UserProfile.extend({
    getDisplayName: function () {
        return this.get('company') || SellerProfile.__super__.getDisplayName.apply(this, arguments);
    },
    displayLabels: {
        trackedPhoneNumber: 'Dedicated Phone Number'
    },
    url: function () {
        return _.result(this.findParent(Seller), 'url') + '/profile';
    }
});

var PriceProfile = SoaModel.extend({
    url: function () {
        return _.result(this.findParent(Seller), 'url') + '/priceProfile';
    }
});

var getSellerAddressModel = function (endpoint) {
    return Address.extend({
        // Assign the url in initialize to overwrite the default
        // url set in the Address model
        initialize: function (options) {
            Address.__super__.initialize.call(this, options);

            this.url = function () {
                return _.result(this.findParent(Seller), 'url') + '/address/' + endpoint;
            };
        },
        //The Address Model syncs new addresses using the addressBook endpoint of buyers,
        //so this needs to be overridden for the seller address sync
        sync: function () {
            return Address.__super__.sync.apply(this, arguments);
        }
    });
};

/**
 * Relations array - For passing all the relations as list to Seller
 * @type {Array}
 */
var relations = [
    {
        key: 'score',
        relatedModel: SoaModel,
        type: Backbone.One
    },
    {
        key: 'priceProfile',
        relatedModel: PriceProfile,
        type: Backbone.One
    },
    {
        key: 'sellerPreferences',
        relatedModel: SellerPreferences,
        type: Backbone.One
    },
    {
        key: 'sellerProfile',
        relatedModel: SellerProfile,
        type: Backbone.One
    },
    {
        key : 'stores',
        collectionType: SoaCollection.extend({
            model: SellerStore
        }),
        type: Backbone.Many
    },
    {
        key: 'stateTaxAdjustments',
        relatedModel : StateTaxAdjustments,
        type: Backbone.One
    },
    {
        key: 'shippingAddress',
        relatedModel: getSellerAddressModel('shipping'),
        type: Backbone.One
    },
    {
        key: 'billingAddress',
        relatedModel: getSellerAddressModel('billing'),
        type: Backbone.One
    },
    {
        key: 'payAddress',
        relatedModel: getSellerAddressModel('pay'),
        type: Backbone.One
    },
    {
        key: 'billingProfile',
        relatedModel: SellerBillingProfile,
        type: Backbone.One,
        omitFromSave: true
    },
    {
        key: 'paymentProfile',
        relatedModel: SellerPaymentProfile,
        type: Backbone.One,
        omitFromSave: true
    },
    {
        key: 'agreements',
        relatedModel: SellerAgreements,
        type: Backbone.One
    },
    {
        key: 'returnPolicies',
        relatedModel: ReturnPolicy,
        type: Backbone.Many
    },
    {
        key: 'shipmentQuotes',
        collectionType: ShipmentQuotes,
        type: Backbone.Many
    },
    {
        key: 'accountManager',
        relatedModel: User,
        type: Backbone.One
    },
    // @deprecated - use tradeAssociations for everything but nydc
    {
        key: 'associations',
        relatedModel: TradeAssociation,
        type: Backbone.One
    },
    {
        key: 'tradeAssociations',
        collectionType: TradeAssociations,
        type: Backbone.Many
    },
    {
        key: 'anchorLists',
        collectionType: AnchorLists,
        type: Backbone.Many
    }
];

root.bunsen = root.bunsen || {};

/**
 * SoaModel
 * @type {*}
 */
_.extend(Seller, { // static methods
    SELLER_ID: 'seller_id',
    STATUS_ACTIVE: 'active',
    STATUS_PENDING: 'pending',
    STATUS_SUSPENDED : 'suspended',
    STATUS_NO_PAY: 'no_pay',
    STATUS_CLOSED: 'closed',
    STATUS_INTERNAL: 'internal',

    // TODO add more (billing profile, account manager, etc)
    // used as fetchRelation flags
    FIELD_SHIPMENT_QUOTE: 'shipmentQuote',
    FIELD_RETURN_POLICY: 'returnPolicy',
    FIELD_PREFERENCE: 'preference',
    SELLER_CURRENT: 'current',

    defaultCollection: Dealers,
    getStatuses: function () {
        return [
            Seller.STATUS_ACTIVE,
            Seller.STATUS_PENDING,
            Seller.STATUS_SUSPENDED,
            Seller.STATUS_NO_PAY,
            Seller.STATUS_CLOSED,
            Seller.STATUS_INTERNAL
        ];
    },
    /**
     * Initialize an empty seller with the correct data structure:
     */
    _initEmptySeller: function () {
        return new Seller({
            'sellerProfile': {},
            sellerPreferences: {},
            stores: [{}],
            billingProfile: {},
            agreements: {},
            shippingAddress: {},
            payAddress: {},
            billingAddress: {}
        });
    },
    /**
     * @param {Object} attrs
     * @returns {Seller}
     * @private
     */
    _createInstance: function (attrs) {
        return new Seller(attrs);
    },
    /**
     * Returns the current seller singleton.
     * Will instantiate it if an `attrs` hash is passed and there it hasn't been instantiated yet.
     *
     * @param {Object} attrs - An attributes hash to instantiate a new seller singleton
     * @returns {Seller|null}
     */
    getCurrentSellerInit: function (attrs) {
        if (!sellers[Seller.SELLER_CURRENT] && attrs) {
            sellers[Seller.SELLER_CURRENT] = this._createInstance(attrs);
        }
        return sellers[Seller.SELLER_CURRENT];
    },

    CONTEMPORARY_NA: 'NOT_APPLICABLE',
    CONTEMPORARY_GALLERY: 'GALLERY',
    CONTEMPORARY_MAKER: 'MAKER_OR_MANUFACTURER',
    CONTEMPORARY_HYBRID: 'HYBRID',
    getContemporaryTypes: function () {
        return [
            Seller.CONTEMPORARY_NA,
            Seller.CONTEMPORARY_GALLERY,
            Seller.CONTEMPORARY_MAKER,
            Seller.CONTEMPORARY_HYBRID
        ];
    }
});
_.extend(Seller.prototype, SoaModelLabelAndValueTransformer, {
    /**
     * @param {String} url
     * @param {String} email
     * @param {String} password
     * @param {Object} oauth - optional
     * @returns {Promise}
     * @private
     */
    _authenticate: function (url, email, password, oauth) {
        var data = this.toJSON();

        return this.clear().save(null, {
            url: url,
            attrs: {
                email: email,
                password: password,
                oauth: oauth
            }
        }).always(function () {
            this.set(_.extend(data, this.toJSON()));
        }.bind(this));
    },
    /**
     * @param {String} email
     * @param {String} password
     * @param {Object} oauth - optional {clientId, redirectUri, state}
     * @returns {Promise}
     */
    login: function (email, password, oauth) {
        return this._authenticate(endpoints.sellerLogin(), email, password, oauth);
    },
    getLegacyId : legacyId.modelHelper,
    displayLabels: {
        id: 'ID'
    },
    schemas: {
        status: {
            type: 'RadioList',
            options: {
                possibleVals: {
                    active: 'Active',
                    inactive: 'Inactive'
                }
            }
        }
    },
    displayTransforms: {
        agreementStart: function (val) {
            return moment(val).format('l');
        },
        createdDate: function (val) {
            return moment(val).format('l');
        }
    },
    getValuesForDetailDisplayString: function () {
        return {
            vertical: this.getVerticalFromID(),
            profile: this.get('sellerProfile'),
            displayName: this.get('sellerProfile').getDisplayName(),
            id: this.get('id'),
            email: this.get('sellerProfile.email')
        };
    },
    idAttribute: 'id',
    /**
     * Passing all relations
     */
    relations: relations,
    /**view
     * @memberof Seller
     * @returns {string}
     * @returns {string}
     */
    url: function () {
        return endpoints.seller(this.get('id'));
    },

    /**
     * Checks if the seller's vertical included in the updated copy pricing verticals list
     * Important: adding a vertical to the list will effect what the dealer see
     * @returns {boolean}
     */
    hasUpdatedPricing: function () {
        var verticalArr = [
            verticals.VERTICAL_FURNITURE
        ];
        return _.contains(verticalArr, this.getVerticalFromID());
    },

    /**
     * Gets the seller's vertical from their ID (the identity service does not return a vertical...
     * @returns {*}
     */
    getVerticalFromID : function () {
        return verticals.getVertical(this.get('id'));
    },
    isVertical: function (vertical) {
        return this.getVerticalFromID() === vertical;
    },
    /*
     * Functions for identifying seller verticals
     * Maybe one day a seller will be in more than one vertical and these will be usefull
     */
    isFurnitureSeller: function () {
        return this.isVertical('furniture');
    },
    isFashionSeller: function () {
        return this.isVertical('fashion');
    },
    isJewelrySeller: function () {
        return this.isVertical('jewelry');
    },
    isArtSeller: function () {
        return this.isVertical('art');
    },
    isStatusSuspended: function () {
        return this.get('status') === Seller.STATUS_SUSPENDED;
    },
    isStatusClosed: function () {
        return this.get('status') === Seller.STATUS_CLOSED;
    },
    isStatusPending: function () {
        return this.get('status') === Seller.STATUS_PENDING;
    },
    /*
     * Function to identify dealers eligible for negotiations 2.0
     */
    isN2Seller: function () {
        // TODO: remove this check altogether if decision is made to permanently scrap n2
        return false;
        //return this.isFashionSeller();
    },
    registerSeller: function (passedOptions, password, vertical) {
        var def = new $.Deferred().resolve();
        var self = this;
        var options = _.defaults({}, passedOptions, {
            attrs: {
                password: password,
                email: this.get('sellerProfile.email')
            },
            url: endpoints.registerSeller(vertical)
        });
        def = def.then(function () {
            var seller;
            if (self.isNew()) {
                // cloning to prevent setting / overriding the url property
                seller = self.clone();
                return seller.save(null, options).then(function () {
                    self.set({id: seller.id});
                    return self.fetch();
                });
            }
        });

        return def;
    },
    getSellerLocation: function () {
        return this.get('stores[0].region.name');
    },
    /**
     * Creates a shipping model -- filled out with local shipping info - and saves to the seller endpoint so that
     * newly created sellers have a default shipping method for local.
     */
    saveSellerLocalShipping : function (options) {
        var shipmentQuote = ShipmentQuote.createLocalPickupQuote({
            handlingTime: {
                numberOfUnits: 2,
                timeUnit: Period.UNIT_BUSINESS_DAY
            },
            type : ShipmentQuote.TYPE_SELLER_PREFERENCES
        });
        var collection = new SoaCollection();
        var shipmentQuoteModel = new SoaModel({
            dataList: collection
        });

        // annoyingly, the service expects data formatted with " dataList : [{...}] " wrapper to accept shipment
        // quote - so we must wrap our data in both a generic SoaModel AND SoaCollection
        collection.add(shipmentQuote);
        shipmentQuoteModel.url = endpoints.sellerQuote(this.get('id'));
        return shipmentQuoteModel.save(null, options);
    },
    /**
     * When new dealers are created this sets a fake legacy key so that they are not automatically instantiated as 1stdibs paris dealers
     * @param passedOptions
     * @returns {*}
     */
    setFakeLegacyKey : function (passedOptions) {
        var options = _.defaults({}, passedOptions, {
            attrs: {
                legacyKey: 'newdealerstub'
            }
        });
        return this.sync('update', this, options);
    },
    /**
     * This saves a agreementStart via PUT
     * @param passedOptions
     * @returns {*}
     */
    saveSellerAgreement : function (passedOptions) {
        var options = _.defaults({}, passedOptions, {
            attrs : this.pick('agreementStart')
        });
        return this.sync('update', this, options);
    },
    newAccountNote: function (passedOptions) {
        _.defaults(passedOptions, {
            type: Note.TYPE_ADMIN_SELLER_ACCOUNT,
            anchors: [
                {
                    sourceId: this.id,
                    sourceType: 'SELLER'
                }
            ]
        });
        return Notes.newNote(passedOptions);
    },
    addNewAccountNote: function (noteOptions, syncOptions) {
        var note = this.newAccountNote(noteOptions);
        return note.save(null, syncOptions);
    },
    saveAccountManager: function (user, saveOptions) {
        var options = {
            url: endpoints.accountManager(this.get('id'))
        };

        _.extend(options, saveOptions);
        return user.save(null, options);
    },

    saveTwentyFirstCenturyStatus: function (options) {
        var status = new TwentyFirstCenturyStatus({
            id: this.id
        });
        return status.save(null, _.extend({
            contentType: 'application/json',
            data: JSON.stringify(this.get('twentyFirstCenturyStatus'))
        }, options));
    },

    /**
     * Checks whether the seller is a member of the given association.
     * @param {String} association name (aadla, adaa, etc...)
     * @returns {Boolean} True if the seller is a member of the association, false otherwise.
     */
    isMemberOf: function (association) {
        var isMember = false;
        var tradeAssociations = this.get('tradeAssociations');
        if (association === TradeAssociation.NAMES.NYDC) {
            isMember = this.get('associations.nydcStatus') === 'Y';
        } else {
            association = (association || '').toUpperCase();
            isMember = tradeAssociations ? tradeAssociations.isAssociationMember(association) : false;
        }
        return isMember;
    },

    /**
     * Returns all associations to which the seller belongs
     * @returns {String[]}
     */
    getAllAssociations: function () {
        return this.get('tradeAssociations').pluck('name');
    },

    /**
     * Checks whether the seller is a member of the given association and corresponding vertical.
     * @param {String} fn Method on the seller model to call to verify vertical (e.g. ADAA members must be art sellers)
     * @param {String} association
     * @returns {Boolean} True if seller is a member of the specified vertical and association, false otherwise.
     * @private
     */
    _isVerticalRestrictedAssociation: function (fn, association) {
        return this[fn]() && this.isMemberOf(association);
    },

    /**
     * Checks whether the seller is a member of AADLA.
     * @returns {Boolean} True if the seller is a furniture seller and a member of AADLA, false otherwise.
     */
    isAntiquesAssociationMember: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.AADLA);
    },

    /**
     * Checks whether the seller is a member of 20th Century Specialists.
     * @returns {Boolean} True if the seller is a furniture seller and a member of 20th Century Specialists, false otherwise.
     */
    is20thCenturySpecialist: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.TWCS);
    },

    /**
     * Checks whether the seller is a member of NYDC.
     * @returns {Boolean} True if the seller is a member of NYDC, false otherwise.
     */
    isNYDCMember: function () {
        return this._isVerticalRestrictedAssociation('isFurnitureSeller', TradeAssociation.NAMES.NYDC);
    },

    /**
     * Checks whether the seller is a member of ADAA (Art Dealers Association of America).
     * @returns {Boolean} True if the seller is an art seller and a member of ADAA, false otherwise.
     */
    isArtDealersAssociationMember: function () {
        return this._isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.ADAA);
    },

    /**
     * Checks whether the seller is a member of AIPAD (Association of International Photography Art Dealers).
     * @returns {Boolean} True if the seller is an art seller and a member of AIPAD, false otherwise.
     */
    isAIPADMember: function () {
        return this._isVerticalRestrictedAssociation('isArtSeller', TradeAssociation.NAMES.AIPAD);
    },
    isDistinguished: function () {
        return this.get('score.distinguishedStatus') === 'DISTINGUISHED';
    },

    /**
     * Returns the antiques association (AADLA) league that the seller belongs to.
     * @returns {String} The AADLA league name.
     */
    getAntiquesAssociationLeague: function () {
        return this.get('tradeAssociations').getAntiquesAssociationLeague();
    },

    /**
     * Checks if seller is a seller in this country.
     * @param {String} countryCode - ISO two char country code
     * @return {Boolean}
     */
    isFromCountry: function (countryCode) {
        return this.get('shippingAddress.country') === countryCode;
    },

    /**
     * Checks if seller is in US
     * @return {Boolean}
     */
    isUSSeller: function () {
        return this.isFromCountry('US');
    },

    /**
     * Checks if seller is on whitelist
     * @param {String} listName - Anchor list name
     * @returns {Boolean}
     */
    isOnWhiteList: function (listType, listName) {
        return this.get('anchorLists') &&
            _(this.get('anchorLists').getListNames(listType)).contains(listName);
    },

    /**
     * Checks if seller is affected by aug 2015 policy changes
     * @return {Boolean}
     */
    isPostAug2015Policy: function () {
        return this.get('anchorLists') &&
            _(this.get('anchorLists').getPolicyNames(false)).contains(AnchorLists.listNames.OPOP);
    },

    /**
     * Performs a request to see if user is on OPOP
     * @return {Promise}
     */
    isOnNewPolicy: function () {
        var anchorLists = new AnchorLists();
        return anchorLists.fetchListForSellerPolicy(this.id).then(function (data) {
            if (data.result.length) {
                return !!_.findWhere(data.result, {name: AnchorLists.listNames.OPOP});
            }
        });
    },

    /**
     * Returns the default return policy.  If undefined, there is no default return policy.
     * @return {Model|null} default policy if found, undefined if not found
     */
    getDefaultReturnPolicy: function () {
        var policy;
        var policies = this.get('returnPolicies');
        if (policies) {
            policy = policies.find(function (p) {
                return p.isDefault();
            });
        }
        return policy;
    },

    /**
     * Returns the fee structures (by id) that can be set for this seller.
     * @param {integer} options.currentFeeStructureId - If editing fee structure, take current id into account
     * @returns {Array|String}
     */
    getFeeStructureOptions: function (options) {
        var currentFeeStructureId;
        var values = [];
        var feeStructureKey;
        options = options || {};
        currentFeeStructureId = options.currentFeeStructureId;

        if (this.get('vertical') === verticals.VERTICAL_FURNITURE) {
            // for furniture seller, options are all flat rate options
            for (feeStructureKey in FeeStructure.feeStructureIds) {
                if (FeeStructure.feeStructureIds.hasOwnProperty(feeStructureKey)) {
                    if (feeStructureKey.startsWith('FLAT_RATE')) {
                        values.push(FeeStructure.feeStructureIds[feeStructureKey]);
                    }
                }
            }

            // if seller already has a fee structure id and it is not one of the regular furniture options,
            // add as first option
            if (currentFeeStructureId && values.indexOf(currentFeeStructureId) === -1) {
                values.unshift(currentFeeStructureId);
            }
        } else {
            // cannot edit fee structure for these verticals, so just return id if one exists
            // otherwise, return default value as single option
            values.push(currentFeeStructureId ? currentFeeStructureId : this.getDefaultFeeStructure());
        }

        return values;
    },

    /**
     * Returns default fee structure for seller. Is TIERED for North American Art sellers, FLAT_RATE_10 for others.
     * @returns {string}
     */
    getDefaultFeeStructure: function () {
        var isNorthAmericanArt = (this.get('vertical') === verticals.VERTICAL_ART && this.get('stores[0].continent.id') === 1);
        return isNorthAmericanArt ? FeeStructure.feeStructureIds.TIERED : FeeStructure.feeStructureIds.FLAT_RATE_10;
    },

    /**
     * Return call to get fee structures for a seller.
     * @returns {Promise}
     */
    getFeeStructures: function () {
        var feeStructures = new FeeStructures();
        var data = {anchors: 'SELLER-' + this.get('id')};
        return Promise.resolve(feeStructures.fetch({data: data})).then(function () {
            return feeStructures;
        });
    },

    /**
     * Checks if seller's payout account status is pre_activated (registered)
     * @returns {boolean}
     */
    isPayoutRegistered: function () {
        return this.get('paymentProfile.status') === 'PRE_ACTIVATED';
    },

    /**
     * Checks if seller's payout account status is activated
     * @returns {boolean}
     */
    isPayoutActivated: function () {
        return this.get('paymentProfile.status') === 'ACTIVATED';
    },

    /**
     * Gets seller's payout account activation code
     * @returns {boolean}
     */
    getPayoutActivationCode: function () {
        return this.get('paymentProfile.activationCode') || '';
    }


}, fetchRelationMixin);

// Static method to retrieve singleton seller
Seller.getCurrentSeller = function () {
    if (!Seller._currentSeller && dataProvider.get('sellerData')) {
        Seller._currentSeller = new Seller(dataProvider.get('sellerData'));
    }
    return Seller._currentSeller;
};

// Static method to send DELETE request to endpoint that sends password reset email
Seller.forgotPassword = function (email, vertical) {
    var SellerPasswordModel = SoaModel.extend({
        url: endpoints.sellerPassword(vertical, {email: encodeURIComponent(email)})
    });
    var model = new SellerPasswordModel();

    return model.sync('delete', model);
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Seller.js
// module id = 105
// module chunks = 64